import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import {
  BonusWrapper,
  HeaderActionsBox,
  BonusFilters,
  BonusList,
  FilterButton,
} from '@/flat-pages/bonuses/ui/styles';
import { SkeletonHeaderItem, BonusItemSkeletonCard } from './styles';

export const BonusSkeleton = () => {
  return (
    <BonusWrapper>
      <HeaderActionsBox>
        <SkeletonHeaderItem>
          <SkeletonLoader height={45} />
        </SkeletonHeaderItem>
      </HeaderActionsBox>

      <BonusFilters>
        {[1, 2].map((el) => (
          <FilterButton key={el}>
            <SkeletonLoader width={60} height={16} />
          </FilterButton>
        ))}
      </BonusFilters>

      <BonusList>
        {[1, 2, 3, 4, 5, 6].map((el) => (
          <BonusItemSkeletonCard key={el}>
            <SkeletonLoader width="100%" height="100%" />
          </BonusItemSkeletonCard>
        ))}
      </BonusList>
    </BonusWrapper>
  );
};
